/**
 * Amplitude Experiment flag keys.
 *
 * Kept in one place so a typo is a compile error rather than a flag that reads
 * as permanently off -- an unknown key evaluates to its fallback, which fails
 * silently and looks identical to "not rolled out yet".
 */
export const FeatureFlag = {
  /**
   * Revamped SOP panel in the Unified Monitoring sidebar: one persistent tabbed
   * SOP card carried across a describe -> talk down -> dispatch flow. Off means
   * the established step-by-step panel, which stays the default everywhere.
   */
  SOP_WORKFLOW_V2: 'sop-workflow-v2',
} as const;

export type FeatureFlagKey = (typeof FeatureFlag)[keyof typeof FeatureFlag];

/** Amplitude's convention for an enabled variant. */
export const FLAG_ON = 'on';
